
export { DialogsComponent } from './dialogs.component';
export { ConfirmDialogComponent } from './confirm-dialog.component';
export { DialogService } from './dialog.service';